// New design system component: stat tile with tinted icon square and optional trend row

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function StatCard({ label, value, icon, color, trend, trendLabel }) {
  const trendUp = typeof trend === "number" && trend >= 0;

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox p={2.25}>
        <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={1.25}>
          <MDTypography
            variant="caption"
            fontWeight="medium"
            sx={({ palette: { text } }) => ({ color: text.main, fontSize: "0.78rem" })}
          >
            {label}
          </MDTypography>
          {icon && (
            <MDBox
              width="2.125rem"
              height="2.125rem"
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={({ palette, functions: { rgba }, borders: { borderRadius } }) => ({
                borderRadius: borderRadius.lg,
                backgroundColor: rgba(palette[color] ? palette[color].main : palette.info.main, 0.12),
                color: palette[color] ? palette[color].main : palette.info.main,
              })}
            >
              <Icon fontSize="small">{icon}</Icon>
            </MDBox>
          )}
        </MDBox>
        <MDTypography variant="h4" fontWeight="bold" sx={{ lineHeight: 1.2 }}>
          {value}
        </MDTypography>
        {(typeof trend === "number" || trendLabel) && (
          <MDBox display="flex" alignItems="center" gap={0.25} mt={0.5}>
            {typeof trend === "number" && (
              <Icon
                sx={({ palette: { success, error } }) => ({
                  fontSize: "0.875rem !important",
                  color: trendUp ? success.main : error.main,
                })}
              >
                {trendUp ? "arrow_upward" : "arrow_downward"}
              </Icon>
            )}
            <MDTypography
              variant="caption"
              fontWeight="medium"
              sx={({ palette: { success, error, text } }) => ({
                fontSize: "0.72rem",
                color:
                  typeof trend === "number" ? (trendUp ? success.main : error.main) : text.main,
              })}
            >
              {typeof trend === "number" ? `${Math.abs(trend)}% ` : ""}
              {trendLabel}
            </MDTypography>
          </MDBox>
        )}
      </MDBox>
    </Card>
  );
}

StatCard.defaultProps = {
  icon: null,
  color: "info",
  trend: undefined,
  trendLabel: "",
};

StatCard.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  icon: PropTypes.node,
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  trend: PropTypes.number,
  trendLabel: PropTypes.node,
};

export default StatCard;
